import { IPreloadedState } from 'shared/types/redux';

export const selectOffersStatus = (state: IPreloadedState) => state.offers.status;
